import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "layers-bold",
  "use": "layers-bold-usage",
  "viewBox": "0 0 17.75 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17.75 18\" id=\"layers-bold\">\n  <path fill-rule=\"evenodd\" d=\"M51.778,433H40.667a1.118,1.118,0,0,0-1.111,1.125V437.5H36.222a1.118,1.118,0,0,0-1.111,1.125v11.25A1.118,1.118,0,0,0,36.222,451H47.333a1.118,1.118,0,0,0,1.111-1.125V446.5h3.333a1.118,1.118,0,0,0,1.111-1.125v-11.25A1.118,1.118,0,0,0,51.778,433Zm-5,16.312h-10V439.187h2.778v6.188a1.118,1.118,0,0,0,1.111,1.125h6.111v2.812Zm4.444-4.5h-10V434.687h10v10.125Z\" transform=\"translate(-35.125 -433)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/layers-bold.svg
// module id = null
// module chunks = 